// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3Vflr","col":"styles_col__2UBjn"};